import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assests/PJ.jpg'
import AVTR2 from '../../assests/IS.jpg'
import AVTR3 from '../../assests/HK.jpg'

// import Swiper core and required modules
import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
//import 'swiper/css';
//import 'swiper/css/navigation';
import 'swiper/css/pagination';

import 'swiper/swiper.min.css'
// import 'swiper/modules/pagination/pagination.min.css'



const data =[
  {
    avatar: AVTR1,
    name: 'Dr. Jawed Aslam',
    position: 'Professor, Media & Communication Studies – UMT',
    review: <h5>"“Muhammad Ahmad was among the most outstanding students I taught at UMT. A gold medalist with a perfect CGPA and a strong grasp of media theory and practice. What truly set him apart is his ability to translate academic concepts into meaningful creative work. I proudly consider him a model student, known for his strong leadership skills, as he frequently took the lead in group projects and multiple competitions.”</h5>
  },
  {
    avatar: AVTR2,
    name: 'Izzah Shaheen',
    position: 'Founder – PictroIzzah',
    review: <h5>"Muhammad Ahmad has been an important part of PictroIzzah for over two years, and watching his growth has been genuinely rewarding. He brings a rare balance of professionalism and creativity to every project, whether it’s photography or cinematic videography. Beyond his technical skills, Ahmad has a strong sense of storytelling, an understanding of client psychology, and a natural awareness of how visuals connect with branding and marketing. He also brings thoughtful historical and cultural context into his work, which adds depth to his visuals. His dedication, curiosity, and creative maturity clearly reflect his potential to grow and succeed on an international level."</h5>
},
  {
    avatar: AVTR3,
    name: 'Hamza Khan',
    position: 'Cinematographer & Manager – PictroIzzah',
    review: <h5>"Working closely with Muhammad Ahmad, I’ve seen him grow into a dependable and thoughtful creative professional. He is receptive to feedback, quick to learn, and consistently delivers under pressure. His international exposure—including shooting a destination wedding in Thailand, shooting and editing wedding films across different cultures and countries sets him apart. He is highly reliable and I’m confident he will continue to grow into larger creative and leadership roles on an international level."</h5>
  }
]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>What Professionals Say</h5>
      <h2>Testimonials</h2>
      <Swiper className='container testimonials_container'
        // install Swiper modules
      pagination={{ clickable: true }}
      modules={[Pagination]} spaceBetween={50}
      slidesPerView={1}
      //navigation = {{draggable: true}}
      
      // scrollbar={{ draggable: true }}
        
      >


      {
        data.map(({avatar, name, position, review}, index) => {
          return(
            <SwiperSlide key={index} className='testimonials'>
          <div className='client_avatar'>
            <img src={avatar} alt=''/>            
          </div>
          <h4 className='client_name'>{name}</h4>
          <h5 className='client_position'>{position}</h5>
          <small className='client_review'>{review}</small>
        </SwiperSlide>

          )
        })
      }
      </Swiper>
    </section>
  )
}

export default Testimonials